// src/pages/Signup.jsx
import React, { useState, useEffect } from 'react';
import api from "../api";
import { useNavigate, Link } from 'react-router-dom';

export default function Signup() {
  const navigate = useNavigate();
  
  const [username, setUsername] = useState('');
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [bio, setBio] = useState('');
  
  const [handleStatus, setHandleStatus] = useState(null);
  const [loadingHandle, setLoadingHandle] = useState(false);
  
  const [err, setErr] = useState('');
  const [info, setInfo] = useState('');

  const checkHandle = async (val) => {
    if (!val || val.length < 3) return setHandleStatus(null);
    setLoadingHandle(true);
    try {
      const r = await api.get(`/users/handle-available?q=${val}`);
      setHandleStatus(r.data.available ? 'available' : 'taken');
    } catch {
      setHandleStatus(null);
    }
    setLoadingHandle(false);
  };

  useEffect(() => {
    const t = setTimeout(() => checkHandle(userId), 400);
    return () => clearTimeout(t);
  }, [userId]);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setInfo('');

    if (handleStatus === 'taken') {
      setErr('Handle already taken');
      return;
    }
    
    if (password !== confirmPassword) {
  setErr("Passwords do not match");
  return;
}
    
    try {
      await api.post("/signup", {
  username,
  email,
  password,
  user_id: userId,
  bio
});

      navigate('/login', {
  state: {
    message: 'Account created — please check your email to verify.'
  }
});
    } catch (e) {
      const msg = e?.response?.data?.error || e.message;
      setErr(msg);
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', padding: 12 }}>
      <h2>Create your Varta account</h2>
      <form onSubmit={submit}>
        
        <label>Full Name</label>
        <input
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          style={{ width: '100%', marginBottom: 12 }}
        />

        <label>Handle (public username)</label>
        <input
          value={userId}
          onChange={e => setUserId(e.target.value.toLowerCase())}
          required
          style={{ width: '100%', marginBottom: 4 }}
          placeholder="e.g. drbhuwan"
        />
        {loadingHandle && <small>Checking…</small>}
        {handleStatus === 'available' && (
          <small style={{ color: 'green' }}>Available ✅</small>
        )}
        {handleStatus === 'taken' && (
          <small style={{ color: 'red' }}>Already taken ❌</small>
        )}

        <br /><br />

        <label>Email</label>
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          type="email"
          required
          style={{ width: '100%', marginBottom: 12 }}
        />

        <label>Password</label>
<input
  value={password}
  onChange={e => setPassword(e.target.value)}
  type="password"
  required
  style={{ width: '100%', marginBottom: 12 }}
/>

<label>Confirm Password</label>
<input
  value={confirmPassword}
  onChange={e => setConfirmPassword(e.target.value)}
  type="password"
  required
  style={{ width: '100%', marginBottom: 12 }}
/>

        <label>Bio (optional)</label>
        <textarea
          value={bio}
          onChange={e => setBio(e.target.value)}
          maxLength={160}
          rows={3}
          style={{ width: '100%', marginBottom: 16 }}
        />

        {err && <div style={{ color: 'crimson', marginBottom: 10 }}>{err}</div>}
        {info && <div style={{ color: 'green', marginBottom: 10 }}>{info}</div>}

        <button type="submit" style={{ width: '100%', padding: 10 }}>
          Sign up
        </button>
      </form>

      <p style={{ marginTop: 14 }}>
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
}